import React, { useEffect } from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import config from "../../config"
//Import Images
import errorImage from "../../assets/images/success-img.jpg"


const Pages500 = () => {
  useEffect(() => {
    document.body.className = "authentication-bg";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  });

  return (
    <React.Fragment>
      <div className="account-pages my-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">

                <CardBody>
                  <div className="text-center p-3">

                    <div className="img">
                      <img src={errorImage} className="img-fluid" alt="Loader" style={{maxHeight:"250px"}}/>
                    </div>

                    {/* <h2 className="error-page mt-5"><span>OK</span></h2> */}
                    <h4 className="mb-4 mt-5">Congratulations</h4>
                    <p className="mb-4 w-75 mx-auto">We are pleased to confirm your successful registration.</p>
                    <a className="btn btn-primary mb-4 waves-effect waves-light" href={config.applicationSettings.webBaseUrl}><i
                      className="mdi mdi-back"></i> Go Back</a>
                  </div>

                </CardBody>
              </Card>

            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Pages500
